export default function buildMembershipPriceBuyable(membership, priceUuid = null) {
  if (!membership) {
    return null;
  }

  let prices = [];

  if (Array.isArray(membership.active_prices)) {
    prices = membership.active_prices;
  } else if (Array.isArray(membership.prices)) {
    prices = membership.prices;
  }

  if (prices.length === 0) {
    return null;
  }

  const selectedPrice = priceUuid
    ? prices.find((price) => price.uuid === priceUuid) || prices[0]
    : prices[0];

  if (!selectedPrice) {
    return null;
  }

  const featureOptions = membership.feature_options || {};

  return {
    ...selectedPrice,
    buyable_type: 'MEMBERSHIP_PRICE',
    name: membership.name,
    picture: membership.picture,
    feature_options: {
      ...featureOptions,
      billing_address: {
        enabled: !!featureOptions?.billing_address?.enabled,
        ...(featureOptions.billing_address || {}),
      },
    },
    subscription: {
      ...membership,
      prices,
    },
  };
}
